import { ref } from 'vue'
import { defineStore } from 'pinia'
import jobApi from '@/api/job'

export const useJobTrackingStore = defineStore('jobTracking', () => {
  const jobTracking = ref({
    applicationId: '',
    email: '',
    jobCode: '',
    jobName: '',
    level: '',
    city: '',
    status: '',
    detail: []
  })

  const getJobTracking = async (applicationId, email) => {
    try {
      const response = await jobApi.getTracking(applicationId, email)
      if (response.body.status.code == 1010) {
        return false
      }

      jobTracking.value = response.body.responseObject
    } catch (error) {
      return false
    }

    return true
  }

  return {
    jobTracking,
    getJobTracking
  }
})
